module.exports = __webpack_public_path__ + "static/media/girl-10.ca5851f0.svg";